<template>
    <AlertManagment/>
</template>
<script>

import AlertManagment from './AlertManagment.vue';
export default {
    name: 'AlertManagementPage',
    components: { AlertManagment }
};
</script>